import React, { useEffect, useState } from 'react';
import {
  Wrap, Card, Message, RingWrap,
} from './QuoteGenerateLoading.styles';

const RADIUS = 48;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
// Never show 0 (looks blocked): the last numbers tick slower and stop at MIN_COUNT.
const MIN_COUNT = 1;
const SLOW_FROM = 5;
const TICK_MS = 1000;
const SLOW_TICK_MS = 2000;

function QuoteGenerateLoading({
  countNr = null,
  message = 'Greenia sta elaborando i tuoi preventivi...',
}) {
  const start = countNr || 60;
  const [counter, setCounter] = useState(start);

  useEffect(() => {
    if (counter <= MIN_COUNT) return undefined;
    const delay = counter <= SLOW_FROM ? SLOW_TICK_MS : TICK_MS;
    const timer = setTimeout(() => setCounter(counter - 1), delay);
    return () => clearTimeout(timer);
  }, [counter]);

  const value = Math.max(counter, 0);
  const dashoffset = CIRCUMFERENCE * (1 - value / start);

  return (
    <Wrap>
      <Card>
        <Message>{message}</Message>
        <RingWrap>
          <svg viewBox="0 0 108 108" width="108" height="108">
            <circle className="track" cx="54" cy="54" r={RADIUS} fill="none" strokeWidth="6" />
            <circle
              className="progress"
              cx="54"
              cy="54"
              r={RADIUS}
              fill="none"
              strokeWidth="6"
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={dashoffset}
            />
          </svg>
          <span className="value">{value}</span>
        </RingWrap>
      </Card>
    </Wrap>
  );
}

export default QuoteGenerateLoading;
